import { Svg } from "common/assets";
import { benefits } from "./data";
import {
  IconEllipse,
  StyledBenefitsItem,
  StyledBenefitsList,
  StyledTitle,
  StyledCountWrapper,
  StyledNumberWrapper,
  StyledTextWrapper,
  
} from "./styled";

export const BenefitsList = () => {
  return (
    <StyledBenefitsList
      cascade
      triggerOnce
      direction="up"
      delay={800}
      duration={500}
      damping={0.5}
    >
      {benefits.map((benefit, index: number) => {
        return (
          <StyledBenefitsItem key={index}>
            <StyledCountWrapper>
              <IconEllipse fill={benefit.color}>
                <use href={Svg.sprite + "#icon-ellipse_number"} />
              </IconEllipse>
              <StyledNumberWrapper>{benefit.number}</StyledNumberWrapper>
              <StyledTitle>{benefit.title}</StyledTitle>
            </StyledCountWrapper>
              <StyledTextWrapper>{benefit.text}</StyledTextWrapper>
          </StyledBenefitsItem>
        );
      })}
    </StyledBenefitsList>
  );
};
